import { useMemo } from 'react';
import type React from 'react';

import { useGetLists } from '@vlabs/api/artemy/client';
import type { Lists } from '@vlabs/api/artemy/model';
import { ListsPreview } from '@vlabs/monokit/shared/ui/person-card/lists-preview';

interface ListsCellProps {
  lists: Lists;
}

function ListsCell({
  lists,
}: ListsCellProps): React.JSX.Element | string | null {
  const { data } = useGetLists({ page_size: 1000 });

  const byId = useMemo(
    () => Object.fromEntries(data?.lists?.map((l) => [l.list_id, l]) ?? []),
    [data],
  );

  if (lists === undefined || lists.length === 0) return null;

  const items = lists.map(
    (list) => (byId[list]?.user_data?.length > 0 ? byId[list]?.user_data : list) as string,
  );

  return (
    <ListsPreview
      items={items}
      tooltipPlacement="top"
    />
  );
}

export { ListsCell };
